<styles-smart-table
  #smartTable
  [datasource]="spaces.items"
  [expandable]="expandable"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [expandedColumns]="['details']"
  [showColumnHeaders]="showColumnHeaders"
>
  <ng-container matColumnDef="spaceName">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div class="container">
        <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
          {{ element | workSpaceType | spaceTypeIcon }}
        </mat-icon>
        {{$any(element)?.name }}
        <framework-space-chip [spaceType]="element | workSpaceType"> </framework-space-chip>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="image"></th>
    <td
      mat-cell
      *matCellDef="let element"
      [attr.rowspan]="smartTable.getImageRows(element)"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="image"
    >
      <framework-assets-image
        image
        [assetSet]="$safeNavigationMigration($any(element)?.defaultAsset)"
        [size]="130"
        [style.height.px]="smartTable.isExpanded(element) ? 104 : 44"
      >
      </framework-assets-image>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      Organization
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      <styles-icon-value-caption caption="Organization" icon="corporate_fare" *ngIf="element.feedDetails">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner">Owner</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="date">Date</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="date">
      <styles-icon-value-caption
        caption="Due date"
        icon="date_range"
        *ngIf="element.status.id !== 'Completed'; else completed"
      >
        {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      <ng-template #completed>
        <styles-icon-value-caption caption="Completion date" icon="date_range">
          {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <td mat-cell *matCellDef="let element" [attr.colspan]="6">
      <div class="details-container">
        <framework-clusted-profile-images
          [userList]="$safeNavigationMigration($any(element)?.parent?.members)"
          [numberToShow]="10"
          *ngIf="element | hasMaster"
        >
        </framework-clusted-profile-images>
        <framework-clusted-profile-images
          [userList]="$safeNavigationMigration($any(element)?.members)"
          [numberToShow]="10"
          *ngIf="!(element | hasMaster)"
        >
        </framework-clusted-profile-images>

        <framework-tag-chip *ngFor="let tag of $any(element).tags" [tag]="tag"> </framework-tag-chip>

        <framework-space-progress-line [space]="element" [rounding]="true" [stroke]="6">
        </framework-space-progress-line>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="default">Name</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | projectRoute">
        <div class="title ellipsis-text">{{$any(element) | projectNamePipe }}</div>
        <div class="sub-title">
          <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
            {{ element | workSpaceType | spaceTypeIcon }}
          </mat-icon>
          <div class="ellipsis-text">{{$any(element)?.name }}</div>
          <framework-space-chip [spaceType]="element | workSpaceType"> </framework-space-chip>
        </div>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="status">Status</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip
        [workStatus]="$safeNavigationMigration($any(element)?.status)"
      ></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="contentType">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      Content Type
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      <styles-icon-value-caption
        caption="Content Type"
        icon="eco"
        *ngIf="$any(element)?.productType; else noContentType"
      >
        {{ $any(element).productType.name }}
      </styles-icon-value-caption>
      <ng-template #noContentType> - </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="progress">
    <td mat-cell *matCellDef="let element" [attr.colspan]="10">
      <elements-progress-line [rounding]="false" [stroke]="8" [gap]="2" [class.disabled]="disableProgressLine === true">
        <elements-progress-group
          name="Plan"
          [accentColour]="(element | spaceTaskCount)!.tasks[0] | workSpaceType | spaceTypeColor"
          *ngIf="element | workInType : 'IdeaProject'"
        >
          <elements-progress-task
            [name]="task.name"
            [complete]="task.status.id === 'Completed'"
            *ngFor="let task of (element | spaceTaskCount)!.tasks"
          >
            <ng-container *ngIf="task.status.id === 'Completed'; else inComplete">
              The {{ task.name }} was completed on {{ $any(task).phaseEnd | date: 'mediumDate' }}
            </ng-container>
            <ng-template #inComplete>
              The {{ task.name }} ie due for completion by {{ $any(task).phaseEnd | date: 'mediumDate' }}
            </ng-template>
          </elements-progress-task>
        </elements-progress-group>
        <elements-progress-group
          name="Produce"
          [accentColour]="(element | spaceTaskCount)!.tasks[0] | workSpaceType | spaceTypeColor"
          *ngIf="element | workInType : 'ProductionProject'"
        >
          <elements-progress-task
            [name]="task.name"
            [complete]="task.status.id === 'Completed'"
            *ngFor="let task of (element | spaceTaskCount)!.tasks"
          >
            <ng-container *ngIf="task.status.id === 'Completed'; else inComplete">
              The {{ task.name }} was completed on {{ $any(task).phaseEnd | date: 'mediumDate' }}
            </ng-container>
            <ng-template #inComplete>
              The {{ task.name }} ie due for completion by {{ $any(task).phaseEnd | date: 'mediumDate' }}
            </ng-template>
          </elements-progress-task>
        </elements-progress-group>
        <elements-progress-group
          name="Publish"
          [accentColour]="(element | spaceTaskCount)!.tasks[0] | workSpaceType | spaceTypeColor"
          *ngIf="element | workInType : 'PublishProject'"
        >
          <elements-progress-task
            [name]="task.name"
            [complete]="task.status.id === 'Completed'"
            *ngFor="let task of (element | spaceTaskCount)!.tasks"
          >
            <ng-container *ngIf="task.status.id === 'Completed'; else inComplete">
              The {{ task.name }} was completed on {{ $any(task).phaseEnd | date: 'mediumDate' }}
            </ng-container>
            <ng-template #inComplete>
              The {{ task.name }} ie due for completion by {{ $any(task).phaseEnd | date: 'mediumDate' }}
            </ng-template>
          </elements-progress-task>
        </elements-progress-group>
      </elements-progress-line>
    </td>
  </ng-container>
</styles-smart-table>
